import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import translationEN from "./locales/en.json";
import translationFR from "./locales/fr.json";
import translationAR from "./locales/ar.json";

const resources = {
  en: { translation: translationEN },
  fr: { translation: translationFR },
  ar: { translation: translationAR },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "fr", // Fallback to French if the specified language translation is missing
    debug: false, // Debug mode
    detection: {
      order: ['localStorage' ],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

// // Force French language on first load if no language preference is stored
// if (!localStorage.getItem('i18nextLng')) {
//   i18n.changeLanguage('fr');
// }

// // Listen for language changes and apply the text alignment dynamically
// i18n.on("languageChanged", (lng) => {
//   if (lng === "ar") {
//     document.body.classList.add("text-align-right"); // Add class for RTL text alignment
//   } else {
//     document.body.classList.remove("text-align-right"); // Remove class when not Arabic
//   }
// });

export default i18n;
